let _serverTimestampMs: number | null = null;
let _sampledAtMonotonicMs: number | null = null;
let _sampleRoundTripMs: number | null = null;

const monotonicNow = (): number =>
  typeof performance !== "undefined" ? performance.now() : Date.now();

const MAX_SAMPLE_AGE_MS = 30_000;

export function setServerTimeDelta(serverTimestampMs: number, roundTripMs = 0): void {
  if (!Number.isFinite(serverTimestampMs)) return;
  const now = monotonicNow();
  const sampleIsStale = _sampledAtMonotonicMs === null || now - _sampledAtMonotonicMs > MAX_SAMPLE_AGE_MS;
  if (!sampleIsStale && _sampleRoundTripMs !== null && roundTripMs > _sampleRoundTripMs) return;

  _serverTimestampMs = serverTimestampMs;
  _sampledAtMonotonicMs = now;
  _sampleRoundTripMs = roundTripMs;
}

export function getServerTimeDelta(): number | null {
  if (_serverTimestampMs === null || _sampledAtMonotonicMs === null) return null;
  return getServerNowMs() - Date.now();
}

export function getServerNowMs(): number {
  if (_serverTimestampMs === null || _sampledAtMonotonicMs === null) return Date.now();
  return _serverTimestampMs + (monotonicNow() - _sampledAtMonotonicMs);
}

export function getEstimatedOneWayLatencyMs(): number {
  return _sampleRoundTripMs !== null ? _sampleRoundTripMs / 2 : 0;
}
